export default __webpack_public_path__ + "img/stage3.5d0a1cb1.png";